export default __webpack_public_path__ + "static/media/g1.2356273b.jpg";